// extracted by mini-css-extract-plugin
module.exports = {"shapeBottom":"TestimonialCard_shapeBottom__wVQOJ","shapeBottomList":"TestimonialCard_shapeBottomList__wddjJ"};